module.exports = __webpack_public_path__ + "image-c24cae783ea3.png";